<template>
  <vue-draggable-resizable drag-handle=".ant-card-head" class="wrap2 attrsDialog" :w="dragW" :h="dragH" :resizable='false' v-if="visible">
    <a-card class="detail-result">
      <span class="primaryColor" slot="title">{{ detailTitle }}</span>
      <a-icon slot="extra" type="close" @click.stop="close" />
      <a-descriptions bordered size="small" :column="1">
        <a-descriptions-item v-for="(value, key, index) in detailInfo" :label="key" :key="index">
          {{ value }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
  </vue-draggable-resizable>
</template>
    
<script>
export default {
  name: 'MarsModal',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      dragW: 360,
      dragH: 760,
      layerName: '',
      detailTitle: '',
      detailInfo: {},
    }
  },
  mounted() {
    // L.DomEvent.disableClickPropagation(this.$el)
    // L.DomEvent.disableScrollPropagation(this.$el)
  },
  methods: {
    /** 
     * @param {object} detailInfo  详细接口返回的数据
     * @param {string} detailTitle  弹框标题
     * @param {arr} attributes  选择的图层的所有属性
     */
    showModal(detailInfo, detailTitle, attributes) {
      console.log('详情查看',detailInfo, detailTitle, attributes);
      this.visible = true
      for (let key in detailInfo) {
        if (detailInfo[key] == 'Null') {
          detailInfo[key] = ''
        }
      }
      if (attributes && attributes.length) {
        this.detailInfo = this.formatAttributes(attributes, detailInfo)
      } else {
        this.detailInfo = detailInfo
      }
      this.detailTitle = detailTitle || '属性查看'
      this.$nextTick(() => {
        this.setZebraStripe()
      })
    },
    formatAttributes(attributes, detailInfo) {
      let attrInfos = {}
      attributes.map((item) => {
        if (item.showable) {
          let name = item.mc || item.name
          let val = detailInfo[name.toLowerCase()] || ''
          attrInfos[item.alias] = val
        }
      })
      return attrInfos
    },
    setZebraStripe(){
      let rows = Array.from(document.querySelectorAll('.attrsDialog .ant-descriptions-row'))
      if(rows.length > 0){
        rows.map((item,i) => {
          if(i % 2 == 1){
            item.classList.add('oddCell')
          }
        })
      }
    },
    close() {
      this.visible = false
      this.$emit('closeDetails')
    },
  },
}
</script>
    
<style lang="less" scoped>
.wrap2 {
  margin-top: 12px;
  border: none;
  /deep/.handle {
    width: 20px;
    border-radius: 10px;
    height: 20px;
    background: rgba(240, 240, 240, 0.6);
    border: 1px solid #ccc;
    z-index: 2;
  }
  position: absolute;
  top: 20%;
  right: 49%;
  // top: -23%;
  // left: -42%;
  z-index: 1 !important;
  height: 600px !important;
  padding: 0;
  border-radius: 4px;
}
.detail-result {
  width: 100%;
  height: 100%;
  min-width: 300px;
  border-radius: 4px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border: none !important;
  /deep/.ant-card-head {
    min-height: 40px;
    padding: 0;
    cursor: all-scroll;
    .ant-card-head-title {
      padding: 0;
    }
    border-bottom: none;
  }
  /deep/ .ant-card-head {
    height: 40px;
    line-height: 40px;
    cursor: move;
    overflow: hidden;
    padding: 0 15px;
    color: #fff;
  }
  /deep/ .ant-card-head-wrapper {
    border-bottom: 1px solid rgba(255, 255, 255, 0.20);
    background-color: transparent;
    line-height: 40px;
    height: 40px;
  }
  /deep/.ant-card-body {
    padding: 12px;
    overflow: auto;
  }
  /deep/.ant-descriptions-item-label,
  /deep/.ant-descriptions-item-content {
    word-break: break-all;
    min-width: 100px;
    color: #fff;
    background: transparent !important;
    border: 0 !important;
  }
  /deep/.ant-card-extra a {
    font-size: 16px;
  }
  /deep/ .ant-descriptions-item-label {
    padding: 5px 12px;
    border-right: 1px solid rgba(255,255,255,0.3) !important;
  }
  /deep/ .ant-descriptions-bordered .ant-descriptions-view {
    border: 1px solid rgba(255,255,255,0.3);
  }
  /deep/ .ant-descriptions-bordered .ant-descriptions-row {
    border-bottom: 1px solid rgba(255,255,255,0.3);
  }
  /deep/ th, /deep/ td {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  /deep/ .oddCell th {
    color: #fff !important;
  }
}
/deep/ .anticon {
  color: #fff !important;
}
</style>
    